import React, { useEffect, useRef, useState } from "react";
import DownloadExcel from "../../../Extra/DownloadExcel";
import axios from "axios";
import { data } from "react-router-dom";

const Head = ["MAXIMUM", "MINIMUM"];
const Head2 = ["RANK", "DATE", "VALUE", "RANK", "DATE", "VALUE"];

const CIEverBest = ({ date, selectedHead }) => {
  const urlCrisPrefix = process.env.REACT_APP_URL_PREFIX_CRIS;
  const tableRef = useRef();
  const [Data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const fetchedData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlCrisPrefix}get_top_bottom_3_data?date=${date}`,
      );
      if (response.data.status === "ok") {
        setData(response.data.data);
      } else {
        setData({});
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchedData();
  }, [date]);
  const headMap = {
    km_dsl_total: "DSL_Loco_KM",
    km_elec_total: "ELEC_Loco_KM",
  };

  const mappedHead = headMap[selectedHead] || selectedHead;

  const dataSets = [
    {
      label: "Current Month",
      data: Data?.current_month_data?.[mappedHead] || {},
    },
    {
      label: "Current Year",
      data: Data?.current_fy_data_till_date?.[mappedHead] || {},
    },
  ];

  return (
    <div>
      <div
        className="table-responsive pt-0 fw-bold "
        style={{ fontSize: "12px", maxHeight: "750px" }}
      >
        <table
          className="table table-hover table-striped glassTable"
          ref={tableRef}
        >
          <thead className="sticky-top table-dark">
            {" "}
            <tr>
              <th colSpan={8}>BEST EVER DATA</th>
            </tr>
            <tr className="align-middle fw-bold">
              <th rowSpan={2}>SR NO</th>
              <th rowSpan={2}>HEADS</th>
              {Head.map((head, i) => (
                <th key={i} colSpan={3}>
                  {head}
                </th>
              ))}
            </tr>
            <tr>
              {Head2.map((col, i) => (
                <th key={i}>{col}</th>
              ))}
            </tr>{" "}
          </thead>
          <tbody>
            {dataSets.map((set, idx) => {
              const top = set.data?.top || [];
              const bottom = set.data?.bottom || [];

              return [0, 1, 2].map((i) => (
                <tr key={`${idx}-${i}`} className="border border-0 border-dark">
                  {i === 0 && (
                    <td rowSpan={3} className="border border-dark">
                      {idx + 1}.
                    </td>
                  )}

                  {i === 0 && (
                    <td rowSpan={3} className="border border-dark">
                      {set.label} ({selectedHead})
                    </td>
                  )}

                  <td>{i + 1}.</td>
                  <td>{top[i]?.record_date?.slice(0, 10) || "-"}</td>
                  <td style={{ color: "green" }}>{top[i]?.value ?? "-"}</td>

                  <td>{i + 1}.</td>
                  <td>{bottom[i]?.record_date?.slice(0, 10) || "-"}</td>
                  <td style={{ color: "red" }}>{bottom[i]?.value ?? "-"}</td>
                </tr>
              ));
            })}
          </tbody>
        </table>
      </div>

      <div className="m-1">
        <DownloadExcel tableRef={tableRef} fileName={`Best Ever ${date}`} />
      </div>
    </div>
  );
};

export default CIEverBest;
